import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';

const SpecialHoldReasonsInput = ({
  splInsOptions = [],
  formData = [],
  setFormData,
  id
}) => {
  const [selectedValue, setSelectedValue] = useState('');

  // Synchronize component state with formData on mount or prop updates
  useEffect(() => {
    const currentItem = (formData || []).find(
      item => String(item.rx_hold_id) === String(id)
    );
    if (currentItem) {
      setSelectedValue(
        currentItem.select_rxreason !== undefined && currentItem.select_rxreason !== null
          ? String(currentItem.select_rxreason)
          : ''
      );
    }
  }, [formData, id]);

  const handleChange = e => {
    const newValue = e.target.value;
    setSelectedValue(newValue);
    if (setFormData && Array.isArray(formData)) {
      const updatedData = formData.map(item => {
        if (String(item.rx_hold_id) === String(id)) {
          return {
            ...item,
            select_rxreason: newValue
          };
        }
        return item;
      });
      setFormData(updatedData);
    }
  };

  return (
    <Form.Select
      size="sm"
      className="form-select form-select-sm"
      value={selectedValue}
      onChange={handleChange}
    >
      <option value="">Select Reason</option>
      {splInsOptions.map((opt, index) => {
        const optionVal =
          opt.value !== undefined
            ? String(opt.value)
            : opt.id !== undefined
            ? String(opt.id)
            : '';
        const optionLabel = opt.key || opt.reason || optionVal;
        if (!optionVal) return null;
        return (
          <option key={index} value={optionVal}>
            {optionLabel}
          </option>
        );
      })}
    </Form.Select>
  );
};

SpecialHoldReasonsInput.propTypes = {
  splInsOptions: PropTypes.array,
  formData: PropTypes.array,
  setFormData: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default SpecialHoldReasonsInput;